import { AUTH_TYPES, AUTH_USER_TYPES, STORE_TYPES } from "../types";
import router from "../../router";
import { getCookie, removeCookie, setCookie } from "../../common/cookie";
import ApiService from "../../common/apiService";
import { getData } from "../../common/dataHelper";
const state = {};

const getters = {
    [AUTH_TYPES.IS_LOGGED_IN]() {
        return getCookie("logged_in");
    },
};

const actions = {
    async [AUTH_TYPES.LOGIN]({ dispatch }, { user }) {
        let expiringDays = 1;
        if (user.stay_logged_in) {
            expiringDays = 365;
        }
        user.password = user.password.trim();
        const response = await ApiService.query("csrf-cookie").then(() => {
            return ApiService.post("academy/login", user);
        });

        if (getData(response, "status") === 200) {
            setCookie("logged_in", true, expiringDays);
            await dispatch(
                `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.FETCH_USER}`,
                {},
                { root: true }
            );

            router.push({ name: "Dashboard" });
        }
        return response;
    },
    async [AUTH_TYPES.LOGIN_WITH_TOKEN]({ dispatch }, { token }) {
        document.cookie.split(";").forEach(function(c) {
            document.cookie = c
                .replace(/^ +/, "")
                .replace(
                    /=.*/,
                    "=;expires=" + new Date().toUTCString() + ";path=/"
                );
        });
        const response = await ApiService.query("csrf-cookie").then(() => {
            return ApiService.post("academy/impersonateIn", { token });
        });

        if (getData(response, "status") === 200) {
            setCookie("logged_in", true, 1);
            await dispatch(
                `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.FETCH_USER}`,
                {},
                { root: true }
            );

            router.push({ name: "Dashboard" });
            return true;
        }
        return false;
    },

    async [AUTH_TYPES.RESET_PASSWORD](context, { user }) {
        const url = `${window.location.origin}/password-change`;
        user.url = url;
        const response = await ApiService.post("academy/forgetPassword", user);
        return response;
    },

    async [AUTH_TYPES.CHANGE_PASSWORD](context, { user }) {
        const response = await ApiService.post("academy/changePassword", user);
        return response;
    },

    async [AUTH_TYPES.LOGOUT]() {
        if (getCookie("logged_in")) {
            removeCookie("logged_in");
        }
        router.push({ name: "Login" });
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
